import React, {Component} from 'react';
import '../css/App.css';
import AddAppointments from './AddAppointments.js';
import SearchAppointments from './SearchAppointments.js';
import ListAppointments from './ListAppointments.js';

import {without} from 'lodash';

class App extends Component {
  constructor() {
    super();
    this.state = {
      myAppointments: [],
      formDisplay: false,
      orderBy: "aptDate",
      orderDir: "asc",
      queryText: "",
      lastIndex: 0
    };
    this.deleteAppointment = this.deleteAppointment.bind(this);
  }

  // if you use anonymous function, no binding needed
  toggleForm = () => {
    this.setState({
      formDisplay: !this.state.formDisplay
    });
  }

  addAppointment = (apt) => {
    let tempApts = this.state.myAppointments;
    apt.aptId = this.state.lastIndex;
    tempApts.unshift(apt);
    this.setState({
      myAppointments: tempApts,
      lastIndex: this.state.lastIndex + 1
    })
  }

  changeOrder = (order, dir) => {
    this.setState({
      orderBy: order,
      orderDir: dir
    });
  }

  searchApts = (query) => {
    this.setState({
      queryText: query
    });
  }

  // binding needed in state if not using anonymous function
  deleteAppointment(apt) {
    let tempApts = this.state.myAppointments;
    tempApts = without(tempApts, apt);

    this.setState({
      myAppointments: tempApts
    });
  }

  componentDidMount() {
    fetch('./data.json')
      .then(response => response.json())
      .then(result => {
        const apts = result.map(item => {
          item.aptId = this.state.lastIndex;
          this.setState({ lastIndex: this.state.lastIndex + 1 });
          return item;
        })
        this.setState({
          myAppointments: apts
        });
      });
  }

  render() {

    let order;
    let filteredApts = this.state.myAppointments;
    if(this.state.orderDir === 'asc'){
      order = 1;
    } else {
      order = -1;
    };

    filteredApts = filteredApts.sort((a,b) => {
      if(a[this.state.orderBy].toLowerCase() < b[this.state.orderBy].toLowerCase()){
        return -1 * order;
      } else {
        return 1 * order;
      }
    }).filter(eachItem => {
      return (
        eachItem["petName"]
        .toLowerCase()
        .includes(this.state.queryText.toLowerCase()) ||
        eachItem["ownerName"]
        .toLowerCase()
        .includes(this.state.queryText.toLowerCase()) ||
        eachItem["aptDate"]
        .toLowerCase()
        .includes(this.state.queryText.toLowerCase())
      );
    });

    return (
      <main className="page bg-white" id="petratings">
      <div className="container">
        <div className="row">
          <div className="col-md-12 bg-white">
            <div className="container">
              <AddAppointments 
                formDisplay={this.state.formDisplay}
                toggleForm={this.toggleForm}
                addAppointment={this.addAppointment}
              />
              <SearchAppointments 
                orderBy={this.state.orderBy}
                orderDir={this.state.orderDir}
                changeOrder={this.changeOrder}
                searchApts={this.searchApts}
              />
              <ListAppointments 
                appointments={filteredApts}
                deleteAppointment={this.deleteAppointment}
                updateInfo={this.updateInfo} 
              />
            </div>
          </div>
        </div>
      </div>
    </main>
    );
  }
}

export default App;
